query AnalyticsViewsByCity($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByCity(limit: $limit) {
      city
      views
      visitors
    }
  }
}
